import { IDynamicSize } from './types';

export * from './types';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const dynamicSize: IDynamicSize = __WEB__ ? require('./web').default : require('./native').default;

export default dynamicSize;
